export default "__VITE_ASSET__Doee9pkf__"